module.exports = __webpack_public_path__ + "img/poisoned.3f557bf3.svg";